import type { JSX } from 'react';

import TenantInactive from '@/components/TenantInactive';
import { useAuth } from '@/contexts/AuthContext';

export const StatusUnavailable = (): JSX.Element => {
  const { isTenantNotFound } = useAuth();

  return <TenantInactive isNotFound={isTenantNotFound} />;
};
